import {initialVaultState} from "../vault/initialVaultState";
import {frontendVersion} from "../../constants/frontendVersion"

export const initialPlanState = {
    version: frontendVersion,
    description: '',
    length: 100,
    width: 100,
    wallWidth: 15,
    // Include children if you want to set an initial value;
    // children reducers can also specify their own initial state.
    vault: initialVaultState
};

